export const ACTIVATION_SUPPLIER_RETAILER = '[activation] supplier_retailer';
export const ACTIVATION_LOADING = '[activation] loading';
